import { DetalleParametrosProyeccionHE } from "components/Admin/Horas Extras/Parametros Horas Extras/TypesParametrosHorasExtras"
import { ActividadesPlanificadas, DetalleGrupoActividadHEDTO, DetalleServidoresPlanificacionHE, InformacionAprobadoresHEDTO, InformacionAprobadorHEDTONovedad, NovedadesServidoresHEDTO, RegimenLaboralHEDTO, ServidorPlanificado } from "../PlanificacionHE/TypesPlanificacionHE"
import { DetalleServidoresModificacionHE } from "../Modificación Presupuesto Unidad/TypesModificacion"


export type DetalleUnidadesHorasExtras = {
    idestructuraorganica: number,
    nombre: string,
    siglas: string,
    idpadre: string,
    articulostr: string
}

export type DetalleModificacionProyeccionHEDTO = {
    listadoServidores: DetalleServidoresProyHEDTO[],
    detalleActividadProyHEDTOs: DetalleActividadProyHEDTO[],
    listadoServidoresOtrasUnidades:DetalleServidoresProyHEDTO[]
}


export type DetalleActividadProyHEDTO = {
    idregimenLaboral: number
    nombreregimenLaboral: string,
    idactividad: number,
    idgrupoactividad:number,
    nombreactividad: string,
    horasSuplementarias: number | undefined,
    valorhorasSuplementarias: number | undefined,
    horasExtraordinarias: number | undefined,
    valorhorasExtraordinarias: number | undefined,
    valortotal: number | undefined,
    observacion: string,
    servidoresPlanificados: Array<{ key: number, value: ServidorPlanificado }>
}


export type DetalleRegimenLaboralProyeccionHEDTO = {
    idRegimenLaboral:number,
    nombreRegimenLaboral:string,
    siglasRegimenLaboral:string,
    horasSuplementarias:number |null,
    horasExtraordinarias:number |null
}

export type PersonalNoProyectadoDTO = {
    nombrescompletos:string,
    cargo:string,
    nombreregimenlaboral:string
}


export type InformacionProyeccionHEDirectivoUnidad = {
    anio: number,
    mensajeError: string,
    idProyUnidadAnio: number,
    estadoProyUnidad: string,
    idSolReverso: number,
    refProyUnidad: string,
    listadoServidores: DetalleServidoresProyHEDTO[],
    // listadoRegimenLaboralesPlan: DetalleRegimenLaboralHEDTO[]
    listadoRegimenLaborales: RegimenLaboralHEDTO[],
    parametrosProyeccion: DetalleParametrosProyeccionHE,
    novedadesServidores: NovedadesServidoresHEDTO[]
    detalleActividadProyHEDTOs: DetalleActividadProyHEDTO[]
    informacionAprobador: InformacionAprobadoresHEDTO//InformacionAprobadorHEDTONovedad,
    gruposActividad: DetalleGrupoActividadHEDTO[],
    listadoServidoresOtrasUnidades:DetalleServidoresProyHEDTO[],
    nombreUnidadAprobacion:string,
    listadoProyeccionPorRegimenLaboral:DetalleRegimenLaboralProyeccionHEDTO[],
    puedeRealizarAccion:boolean,
    nroServidoresDeLaUnidad:number,
    nroServidoresProyectados:number,
    nroServidoresNoProyectados:number,
    nroHorasProyectadas:number,
    personalNoProyectado:PersonalNoProyectadoDTO[]
    //unidadesHorasExtras: DetalleUnidadesHorasExtras[],

}


export type DetalleServidoresProyHEDTO = {
    contador: number,
    idpersona: number,
    idheproyunidadanio: number,
    idheproypersona: number,
    idcontratolaboral: number,
    tipo: string | null,
    identificacion: string,
    nombrescompletos: string
    cargo: string,
    rmu: string
    idregimenlaboral: number,
    nombreregimenlaboral: string,
    siglasregimenlaboral: string,
    numactividades: number | null,
    horasextraordinarias: number | null,
    horassuplementarias: number | null,
    horastotales: number | null,
    valorhorasextraordinarias: number | null,
    valorhorassuplementarias: number | null,
    valortotal: number | null,
    strestadoproyeccion: string,
    estadoproyeccionpersona:string,
    estadoproyeccionpersonaunidad:string,
    estadoproyeccionunidad:string,
    idestructuraorganica?:number|null,
    nombreestructuraorganica?:string,
    actividadesplanificadas: Array<{ key: number, value: ActividadesPlanificadas }>
}

export type InformacionServidoresOtrasUnidadesHEDTO = {
    idpersona:number,
    identificacion:string,
    nombrescompletos:string,
    cargo:string,
    rmu:string,
    idregimenlaboral: number,
    nombreregimenlaboral: string,
    siglasregimenlaboral: string,
    tipo: string | null,
    idcontratolaboral: number,
    idestructuraorganica:number,
    nombreestructuraorganica:string
}


export type DetalleProyeccionAnio = {
    horasSuplementarias:number | null 
    horasExtraordinarias :number | null 
    totalHoras :number | null 
    presupuestoAsignado :number | null 
    presupuestoModificado :number | null 
    presupuestoCodificado :number | null 
    presupuestoEjecutado :number | null 
}

export type ProyeccionHistoricoHEDTO = {
    anio:number,
    puedeIngresar:boolean,
    periodoVigente:boolean,
    detalle:DetalleProyeccionAnio
}

export type TipoDetalleServidoresHE = DetalleServidoresPlanificacionHE | DetalleServidoresProyHEDTO | DetalleServidoresModificacionHE

export function isParametroRegimenProyeccion(parametro: TipoDetalleServidoresHE): parametro is DetalleServidoresProyHEDTO {
    return (parametro as DetalleServidoresProyHEDTO).strestadoproyeccion !== undefined;
}

export function isProyeccion(parametro: TipoDetalleServidoresHE): parametro is DetalleServidoresProyHEDTO {
    return (parametro as DetalleServidoresProyHEDTO).strestadoproyeccion !== undefined;
}

export function isParametroRegimenPlanificacion(parametro: TipoDetalleServidoresHE): parametro is DetalleServidoresPlanificacionHE {
    return (parametro as DetalleServidoresPlanificacionHE).strestadoplanificacion !== undefined;
}

export function isPlanificacion(parametro: TipoDetalleServidoresHE): parametro is DetalleServidoresPlanificacionHE {
    return (parametro as DetalleServidoresPlanificacionHE).strestadoplanificacion !== undefined;
}

export function isParametroRegimenModificacion(parametro: TipoDetalleServidoresHE): parametro is DetalleServidoresModificacionHE {
    return (parametro as DetalleServidoresModificacionHE).strestadomodificacion !== undefined;
}

export function isModificacion(parametro: TipoDetalleServidoresHE): parametro is DetalleServidoresModificacionHE {
    return (parametro as DetalleServidoresModificacionHE).strestadomodificacion !== undefined;
}